import React, { useState, useEffect } from 'react'
import api from '@services/api'
import { useHistory, useLocation } from 'react-router-dom'
import MessageModal from '@components/Modals/MessageModal'
import ConfirmModal from '@components/Modals/ConfirmModal'
import SubmitButton from '@components/Buttons/SubmitButton'
import DisableUserButton from '@components/EditUser/DisableUserButton'
import { SubmitBtnContainer, SubmitButtonsRow } from '@appearance/styled'
import i18n from '@localization/i18n'

export default ({ user, preEditUser }) => {
    const history = useHistory()
    const location = useLocation()
    const [showConfirmModal, setShowConfirmModal] = useState(false)
    const [showDoneModal, setShowDoneModal] = useState(false)

    const onCloseDoneModal = () => {
        setShowDoneModal(false)
        history.goBack()
    }

    const formIsValid = () => {
        if (user === preEditUser) {
            return false
        }
        return true
    }

    const onConfirmModalCancel = () => {
        // console.log('onConfirmModal Cancel clicked')
        setShowConfirmModal(false)
    }

    const saveUser = () => {
        setShowConfirmModal(false)
        // console.log('save user ', user)
        api.saveUser(user).subscribe(
            (res) => {
                // console.log('saveUser res', res)
                setShowDoneModal(true)
            },
            (error) => console.log('saveUser error', error)
        )
    }

    return (
        <SubmitButtonsRow>
            <SubmitBtnContainer>
                <SubmitButton
                    label={i18n.t('edit_user.save_button')}
                    onClick={() => setShowConfirmModal(true)}
                    disabled={!formIsValid()}
                />
            </SubmitBtnContainer>
            <SubmitBtnContainer>
                <SubmitButton
                    theme={'white'}
                    label={i18n.t('edit_user.cancel_button')}
                    onClick={() => history.goBack()}
                />
            </SubmitBtnContainer>
            {location && location.pathname.includes('/edit_user') && (
                <SubmitBtnContainer>
                    <DisableUserButton user={user} />
                </SubmitBtnContainer>
            )}

            <ConfirmModal
                isOpen={showConfirmModal}
                title={i18n.t('edit_user.save_changes_modal_headline')}
                mainText={i18n.t('edit_user.save_changes_modal_content')}
                onConfirm={saveUser}
                onCancel={onConfirmModalCancel}
            />
            <MessageModal
                isOpen={showDoneModal}
                title={i18n.t(
                    'edit_user.changes_succussfully_saved_modal_title'
                )}
                mainText={i18n.t(
                    'edit_user.changes_succussfully_saved_modal_content'
                )}
                onClose={onCloseDoneModal}
            />
        </SubmitButtonsRow>
    )
}
